import React from 'react';
import { Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

function NoResultsView() {
  const { t } = useTranslation();
  return (
    <Grid
      display="flex"
      flexDirection="row"
      gap={2}
      alignItems="center"
      justifyContent="center"
      height="calc(100% - 70px)"
    >
      <img src="/assets/icons/clipboard-remove.svg" alt="clipboard-remove" width={32} height={32} />
      <Typography variant="bodyBold" color="primary">
        {t('common.noResultsFound')}
      </Typography>
    </Grid>
  );
}

export default NoResultsView;
